import React from "react";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import IpdRelease from "./ipdRelease";



const IpdReleaseContainer = () => {
    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <Navbar />
                <IpdRelease />

            </div>
        </div>
    )
}

export default IpdReleaseContainer;
